import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationLocationAamsConstants {
    static REMOVE_ADVERTISEMENT_LABEL = "Remove advertisement";
    static DESCRIPTION_LABEL_1 = "Search the map to find the advertisement for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in to the correct advertisement and click on the advertisement. For permanent applications, please put a point on where it will be.";
    static DESCRIPTION_LABEL_3 = "For temporary applications, please draw an area around where all your advertisements will be placed.";
    static AREA_OF_DISPLAY_FORM_CONTROL_NAME = "areaOfDisplay";
    static STREET_NAMES_FORM_CONTROL = "streetNames";
    static PROPERTY_DESCRIPTION_FORM_CONTROL_NAME = "propertyDescription";
    static ADDRESS_OR_STREET_FORM_CONTROL_NAME = "addressStreetInformation";
    static AREA_OF_CONTROL_LABEL = "Area of control";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static STREET_NAMES_LABEL = "Street names";
    static PROPERTY_DESCRIPTION_LABEL = "Property description (If it is a private sale or permanent advertisement)";
    static ADDRESS_OR_STREET_LABEL = "Address / Street information";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static ADVERTISEMENT_TYPE_NOT_SELECTED_MESSAGE = "Please select whether the application is for a permanent or temporary advertisement in the application details tab";
    static VALIDATION_MESSAGES = {
        areaOfDisplay: {
            required: `Area of display ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        streetNames: {
            required: `Street names ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        propertyDescription: {
            required: `Property description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        addressOrStreet: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
    static POLYGON_SKETCH_TOOLS_OPTIONS = {
        createTools: {
            point: false,
            circle: false,
            polyline: false,
            rectangle: false
        },
        selectionTools: {
            "lasso-selection": false,
            "rectangle-selection": false
        }
    };
    static POINT_SKETCH_TOOLS_OPTIONS = {
        createTools: {
            circle: false,
            polygon: false,
            polyline: false,
            rectangle: false
        },
        selectionTools: {
            "lasso-selection": false,
            "rectangle-selection": false
        }
    };
}
